import {
    AuthorizePatientDataAccessDto,
    PatientDataAccessAppointmentDataDto,
    PatientDataAccessStatusDto,
} from '../../types/patientDataAccess';
import {P1Response} from '../../types/p1Service';
import {P1Service} from '../../services/P1Service';
import {
    APPLY_PATIENT_DATA_ACCESS,
    AUTHORIZE_PATIENT_DATA_ACCESS,
    STATUS_PATIENT_DATA_ACCESS,
} from './patientDataAccessEndpoints';

class PatientDataAccessApi {
    applyForPatientDataAccess(
        appointmentData: PatientDataAccessAppointmentDataDto,
    ) {
        return P1Service.post(APPLY_PATIENT_DATA_ACCESS, appointmentData);
    }

    authorizePatientDataAccess(patientData: AuthorizePatientDataAccessDto) {
        return P1Service.post(AUTHORIZE_PATIENT_DATA_ACCESS, patientData);
    }

    getPatientDataAccessStatus(
        appointmentData: PatientDataAccessAppointmentDataDto,
    ) {
        return P1Service.post<P1Response<PatientDataAccessStatusDto>>(
            STATUS_PATIENT_DATA_ACCESS,
            appointmentData,
        );
    }
}

export default new PatientDataAccessApi();
